import { Component, Input } from '@angular/core';
import { IUnifiedDocument } from '../../../../core/interfaces/unified-background-check.interface';

@Component({
  selector: 'app-bgc-section-documents',
  templateUrl: './bgc-section-documents.component.html',
  styleUrls: ['./bgc-section-documents.component.scss', '../../driver-background-check.component.scss']
})
export class BgcSectionDocumentsComponent {
  @Input() documents: IUnifiedDocument[] = [];
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/components/bgc-section-documents/bgc-section-documents.component.ts